import { createFeatureSelector, createSelector } from "@ngrx/store";

import { State, UserState, USER_FEATURE_KEY } from "../interfaces";

const state = createFeatureSelector<State, UserState>(USER_FEATURE_KEY);

export const selectUser = createSelector(state, state => state.user);